import React, { useState } from "react"
import { Button, Col, FormGroup, Modal, Row } from "reactstrap"
// import "boxicons"
import Dropzone from "react-dropzone"
import "react-circular-progressbar/dist/styles.css"
import { TiDelete } from "react-icons/ti"
import FilePreview from "./FilePreview"

const ViewFiles = ({ viewFilesToggle, viewedFiles, handleFileChange, doc }) => {
  //************* form control ******/
  const [modal, setmodal] = useState(true)
  const toggle = () => {
    viewFilesToggle()
  }
  const onClose = () => {
    viewFilesToggle()
  }

  const [errorMsg, setErrorMsg] = useState({ ar: "", en: "" })
  console.log("errorMsg ----------------------------------", errorMsg)

  const [loading, setloading] = useState(false)
  const [autoClose, setAutoClose] = useState(false)
  const toggleAutoClose = () => {
    setAutoClose(!autoClose)
  }

  const [allImages, setAllImages] = useState(viewedFiles)
  const [selectedFiles, setSelectedFiles] = useState([])
  const [unselectedFiles, setUnSelectedFiles] = useState([])

  const [dropzone, setDropzone] = useState(false)

  // for view image
  const [isOpen, setIsOpen] = useState(false)
  const [currentImage, setCurrentImage] = useState(null)

  // drop and drag
  const handleDragEnter = e => {
    e.preventDefault()
    e.stopPropagation()
    setDropzone(true)
  }

  const handleDragOver = e => {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleDragLeave = e => {
    e.preventDefault()
    e.stopPropagation()
    setDropzone(false)
  }

  const handleDrop = (acceptedFiles, rejectedFiles) => {
    console.log("e", acceptedFiles, rejectedFiles)

    if (rejectedFiles?.length) {
      alert("Only PDF files are allowed!")
      return
    }

    // e.preventDefault();
    // e.stopPropagation();
    const files = doc.multi ? acceptedFiles : [acceptedFiles[0]]
    setSelectedFiles([...selectedFiles, ...files])
    setAllImages([...allImages, ...files])
    setDropzone(false)
  }

  const submitHandler = () => {
    if (!doc.multi && allImages.length > 1) {
      return setErrorMsg({ ar: "ملف واحد فقط", en: "only one file" })
    }

    setErrorMsg({ ar: "", en: "" })

    handleFileChange(doc, doc.id, allImages)
    viewFilesToggle()
  }

  const fileClickHandler = file => {
    const pdfUrl = URL.createObjectURL(file)
    window.open(pdfUrl, "_blank")
  }

  return (
    <Modal isOpen={modal} toggle={toggle} className="modal-lg">
      <div className="m-auto">
        <div
          className="m-auto mt-3 d-flex flex-wrap justify-content-center"
          style={{ maxWidth: "684px" }}
        >
          <ul className="list-unstyled mb-3" id="file-previews">
            {(allImages || [])?.map((file, index) => {
              return (
                <li className="mt-2 dz-image-preview" key={index}>
                  <div className="border rounded">
                    {/* <div className="d-flex flex-wrap gap-2 p-2"> */}
                    <Row className="d-flex justify-content-center align-items-center p-3">
                      <Col sm={2}>
                        <div className="flex-shrink-0 me-3">
                          <div className="avatar-sm bg-light rounded p-2">
                            <FilePreview data={file} />
                          </div>
                        </div>
                      </Col>
                      <Col sm={8}>
                        <div
                          className="flex-grow-1 "
                          style={{ cursor: "pointer" }}
                          onClick={() => fileClickHandler(file)}
                        >
                          <div className="pt-1">
                            <h5 className="fs-md mb-1 " data-dz-name>
                              {/* {file.path.slice(0, 20)} */}
                              <a>{file.name}</a>
                            </h5>
                            <strong
                              className="error text-danger"
                              data-dz-errormessage
                            ></strong>
                          </div>
                        </div>
                      </Col>
                      <Col sm={2}>
                        <div className="flex-shrink-0 ms-3">
                          <TiDelete
                            style={{
                              fontSize: "28px",
                              color: "red",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              const newImages = [...allImages]
                              newImages.splice(index, 1)
                              setAllImages(newImages)
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    {/* </div> */}
                  </div>
                </li>
              )
            })}
          </ul>

          <Dropzone
            accept={doc.accept}
            multiple={doc.multi}
            maxFiles={doc.multi ? 10 : 1}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            {({ getRootProps, getInputProps }) => (
              <div className="dropzone cursore-pointer">
                <div
                  className="dz-message needsclick text-center"
                  {...getRootProps()}
                >
                  <input
                    {...getInputProps({
                      accept: doc.accept,
                      multiple: doc.multi,
                      maxFiles: doc.multi ? 10 : 1,
                    })}
                  />

                  <div className="dz-message needsclick p-2">
                    <div className="mb-3">
                      <i className="display-6 text-muted bx bxs-cloud-upload" />
                    </div>

                    <h4>Drop files here or click to upload.</h4>

                    <p className="text-danger">
                      {doc.multi ? "max 10 files" : "only one file"}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </Dropzone>

          {/* {isOpen && (
            <ImageZoomModal
              isOpen={isOpen}
              onRequestClose={() => setIsOpen(false)}
              imageSrc={currentImage}
            />
          )} */}
        </div>

        <Row>
          <Col className="d-flex justify-content-end">
            <p className="text-danger">{errorMsg.en}</p>
          </Col>
        </Row>

        <FormGroup className="d-flex justify-content-end gap-3 mt-2 px-3">
          <Button
            type="button"
            onClick={submitHandler}
            disabled={doc.required && allImages.length === 0}
            className="bg-black px-4 py-2 rounded-3"
          >
            Submit
          </Button>
        </FormGroup>
      </div>
    </Modal>
  )
}

export default ViewFiles
